import type React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { useProducts } from '@features/cart/products/model';
import { Logo } from '@features/common';
import { ButtonCart, ButtonLogin, DesktopLinks, ProfileMenu } from '@features/header';
import { ButtonSupport } from '@features/support';
import { useUser, useWindowWidth } from '@shared/hooks';
import { useScroll } from '@shared/hooks/use-scroll';
import { HeaderMobile } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = {
  MCenter: JSX.Element;
  menuClassName?: string;
  noTransform?: boolean;
  isHiddenHamburger?: boolean;
};

export const Header: React.FC<Props> = ({ MCenter, menuClassName, isHiddenHamburger }) => {
  const logoRef = useRef<HTMLDivElement>(null);
  const navRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const [headerWidth, setHeaderWidth] = useState(0);

  const { isAuth } = useUser();

  const { transformHeader } = useScroll();

  const products = useProducts();

  const windosWidth = useWindowWidth();

  const checkScreenWidth = () => {
    if (navRef.current && logoRef.current && menuRef.current)
      setHeaderWidth(
        logoRef.current.offsetWidth + navRef.current.offsetWidth + menuRef.current.offsetWidth + 70
      );

    if (!(windosWidth <= 768 || headerWidth > windosWidth)) {
      document.getElementById('body')
        ? (document.getElementById('body')!.style.display = '')
        : null;

      document.getElementById('nav-bar')
        ? (document.getElementById('nav-bar')!.style.display = '')
        : null;
    }
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', checkScreenWidth);
    window.addEventListener('load', checkScreenWidth);

    return () => {
      window.removeEventListener('resize', checkScreenWidth);
      window.removeEventListener('load', checkScreenWidth);
    };
  }, [windosWidth]);

  useLayoutEffect(() => {
    checkScreenWidth();
  });

  return windosWidth <= 768 || headerWidth > windosWidth ? (
    <HeaderMobile
      Center={MCenter}
      transformHeader={transformHeader}
      menuClassName={menuClassName}
      isHiddenHamburger={isHiddenHamburger}
    />
  ) : (
    <header
      className={st.header}
      style={{
        transform: `${transformHeader}`,
        transition: 'transform 0.5s ease-in-out',
      }}
    >
      <div
        className={st.desktop}
        style={{
          opacity: transformHeader !== 'translateY(0)' ? '0' : '1',
          transition: '1s  ease-in-out',
          visibility: transformHeader !== 'translateY(0)' ? 'hidden' : 'visible',
        }}
      >
        <div className={st.desktop__logo} ref={logoRef}>
          <Logo />
        </div>
        <nav className={st.desktop__nav} ref={navRef} id="nav-menu">
          <DesktopLinks />
        </nav>
        <nav className={st.desktop__menu} ref={menuRef}>
          {isAuth && products.items && products.items.length > 0 && <ButtonCart />}

          {/*{isAuth && <ButtonMessenger />}*/}
          {/* {isAuth && <ButtonNotifications />} */}
          {!isAuth && <ButtonSupport />}

          {isAuth ? <ProfileMenu /> : <ButtonLogin />}
        </nav>
      </div>
    </header>
  );
};
